module.exports = __webpack_public_path__ + "static/media/center-marker-icon.8d8a1e27.png";